import React from 'react'
import { BlockUI } from 'primereact/blockui'
import { ProgressSpinner } from 'primereact/progressspinner'

// While the layout catalog loads, a mask covers the wrapped content so nothing in it can be clicked
// until the catalog it depends on is ready. The content still renders underneath.
export default function CatalogLoadingOverlay ({ loading, children }) {
  return (
    <BlockUI
      blocked={loading}
      containerClassName='layoutBuilder-catalog-overlay'
      // The mask's z-index is set above the last opened modal; isolating it keeps it under any dialog.
      containerStyle={{ isolation: 'isolate' }}
      className='layoutBuilder-catalog-overlay-mask'
      template={(
        <div className='layoutBuilder-catalog-loading' role='status'>
          <ProgressSpinner style={{ width: '2.5rem', height: '2.5rem' }} strokeWidth='4' aria-hidden='true' />
          <p>Loading integration catalog…</p>
        </div>
      )}
    >
      {children}
    </BlockUI>
  )
}
